<template>
<!-- 青岛出入金相关 -->
  <div id="MyWithdraw">
    <div class="headerContent">
      <div class="contentWrap1">
        <p>
          可出金额：<span>{{ myAccount.canOutMoney | toThousands }}</span>
        </p>
        <!-- <p>
          上日权益：<span>{{ myAccount.lastRight | toThousands }}</span>
        </p> -->
      </div>
    </div>
    <div class="centerContent">
      <div class="leftContent">
        <div class="topTitle">入金</div>
        <div class="textWrap">
          <p class="tip">
            <i class="el-icon-warning"></i>&nbsp;温馨提示:
            入金时间为&nbsp;&nbsp;
            <span>交易日9:00-16:00</span>
          </p>
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <div class="desc">
                <p class="title">收款方开户行</p>
                <p class="text1">{{ bankDetails.openBankName }}</p>
                <p
                  v-clipboard:copy="bankDetails.openBankName"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
              <div class="desc">
                <p class="title">收款方账号</p>
                <p class="text1">{{ bankDetails.bankAccount }}</p>
                <p
                  v-clipboard:copy="bankDetails.bankAccount"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
              <div class="desc">
                <p class="title">收款方户名</p>
                <p class="text1">{{ bankDetails.bankAccountName }}</p>
                <p
                  v-clipboard:copy="bankDetails.bankAccountName"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="topTitle">出金</div>
        <div class="textWrap">
          <p class="tip">
            <i class="el-icon-warning"></i>&nbsp;温馨提示:
            出金时间为&nbsp;&nbsp; <span>周一到周五&nbsp;&nbsp;9:00-16:00</span>
          </p>
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <p class="desc">
                <span class="title">出金金额</span>
                <el-input
                  v-model="ruleForm.amount"
                  :placeholder="'可出金额   ' + myAccount.canOutMoney"
                >
                  <template slot="suffix">
                    <span class="iconCopy" @click="getAllMoney">全部</span>
                  </template>
                </el-input>
              </p>
              <p class="desc">
                <span class="title">资金密码</span>
                <el-input
                  v-model="ruleForm.password"
                  :type="passType"
                  auto-complete="new-password"
                  placeholder="请输入密码"
                >
                  <template slot="suffix">
                    <img
                      class="eyeStyle"
                      :src="passwordIcon"
                      alt=""
                      @click="changeType"
                    >
                  </template>
                </el-input>
              </p>
            </div>
          </div>
          <div class="btnWrap">
            <el-button
              :loading="loading"
              :disabled="btnDisenable"
              type="primary"
              @click="handleSubmit"
            ><span style="color:#fff">提交</span></el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 出入金流水 -->
    <div class="flow">
      <div class="headerWrap">
        <div class="leftText">出入金流水</div>
        <!-- <div class="rightText">
          <div class="selectText">类型</div>
          <el-select v-model="typeCode" placeholder="请选择">
            <el-option label="全部" value="102" />
            <el-option label="出金" value="101" />
            <el-option label="入金" value="101" />
            <el-option label="出金错误回滚资金" value="101" />
          </el-select>
          <el-date-picker
            v-model="selectData"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin:3px 13px 0 13px"
            value-format="yyyyMMdd"
          />
          <el-button
            type="danger"
            @click="param_queryMyIntegralDetail"
          >查询</el-button>
          <el-button type="success" @click="resetData">重置</el-button>
        </div> -->
      </div>
      <div class="tableWrap">
        <el-table :data="tableData" border style="width: 100%">
          <template slot="empty">
            <div class="no-datas1">
              <div
                class="no-data-img"
                style="margin: 100px auto 0px; width: 120px; height: 200px;"
              >
                <img
                  src="../../../assets/images/no_data.png"
                  alt=""
                  style="width: 100%;"
                >
              </div>
            </div>
          </template>
          <el-table-column align="center" prop="bizName" label="类型">
          </el-table-column>
          <el-table-column align="center" prop="amount" label="发生额">
          </el-table-column>
          <el-table-column prop="occurTime" label="时间">
            <template slot-scope="scope">
              {{ scope.row.occurTime | dateFormate }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="flowId" label="市场流水号">
          </el-table-column>
          <el-table-column align="center" prop="bankFlowId" label="银行流水号">
          </el-table-column>
        </el-table>
        <el-pagination
        popper-class='_popStyle'
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
export default {
  data() {
    return {
      loading: false,
      bankId: null,
      passType: 'password',
      passwordIcon: '',
      openImg: require('../../../assets/images/icon/openeye.png'),
      closeImg: require('../../../assets/images/icon/closeeye.png'),
      selectData: '',
      typeCode: null,
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      },
      bankDetails: {
        bankAccount: '15116501040020933',
        bankAccountName: ' 山东交易市场清算所有限公司',
        openBankName: '中国农业银行股份有限公司济南自贸区支行',
        openBankNumber: null,
        signFlag: null
      },
      typeFlag: 'text',
      isWithdraw: false,
      /** 银行 */
      banks: [],
      /** 银行 end */
      ruleForm: {
        bankId: '',
        amount: '',
        password: ''
      },
      btnDisenable: false,
      myAccount: {
        accountId: 0,
        avilibleMargin: 0,
        balance: 0,
        createTime: 0,
        currency: '人民币',
        enName: 'CNY',
        firmId: 0,
        frozenFunds: 0,
        lastBalance: 0,
        marketId: 32,
        marketName: '现货买进',
        marketType: '主市场',
        updateTime: 0
      }
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'h_accountTime',
      'myassetDataGetter',
      'h_sumClosePl',
      'marketStatusGetter'
    ])
  },
  mounted() {
    this.bankInfo()
    this.getMyAccount()
    this.param_queryMyIntegralDetail()
    this.passwordIcon = this.closeImg
  },
  methods: {
    // 查询开户信息 --- 获取签约信息
    bankInfo() {
      http.postFront(protocol.param_findTrader).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.bankId = value.bankId
          }
        } else {
          this.$message(message)
        }
      })
    },
    getAllMoney() {
      this.ruleForm.amount = this.myAccount.canOutMoney
    },
    changeType() {
      this.passType = this.passType == 'password' ? 'text' : 'password'
      this.passwordIcon =
        this.passType == 'password' ? this.closeImg : this.openImg
    },
    onCopy() {
      this.$message('复制成功')
    },
    onError() {
      this.$message('复制失败')
    },
    resetData() {
      this.selectData = ''
      this.typeCode = null
      this.tableData = []
      this.pageData = {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
      this.param_queryMyIntegralDetail()
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询出入金流水
    param_queryMyIntegralDetail() {
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.bizCode = null
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.page =
        this.pageData.currentPage - 1
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.size = this.pageData.pageSize
      http
        .postFrontChange(
          protocol.param_queryFirmBankAccountInoutFundsFlowFront,
          0
        )
        .then(response => {
          const { code, value, message } = response.data
          if (Number(code) == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            this.tableData = arr
          } else {
            this.$message(message)
          }
        })
    },
    // 得到可出金额和上日权益
    getMyAccount() {
      http.getNewPath2Market0(protocol.param_mineAsset).then(response => {
        const { code, value, message } = response.data
        if (Number(code) == 0) {
          if (value) {
            this.myAccount = value
            if (this.myAccount.canOutMoney < 0) {
              this.myAccount.canOutMoney = 0
            }
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 出金提交
    handleSubmit(name) {
      const reg = /^\d{6}$/
      const regMoney = /^[1-9](\d+)?(\.\d{1,2})?$/
      if (!this.ruleForm.amount) {
        this.$message('请输入出金金额')
        return false
      } else if (!regMoney.test(this.ruleForm.amount)) {
        this.$message('请输入正确的出金金额')
        return false
      } else if (!this.ruleForm.password) {
        this.$message('请输入资金密码')
        return false
      } else if (!reg.test(this.ruleForm.password)) {
        this.$message('请输入正确的资金密码')
        return false
      }
      protocol.param_marketOutFund_qd.param.pwd = md5(
        '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.ruleForm.password
      )
      protocol.param_marketOutFund_qd.param.bankId = 30 // 青岛的写死30
      protocol.param_marketOutFund_qd.param.amount = Number(this.ruleForm.amount)
      protocol.param_marketOutFund_qd.param.marketId = 0
      protocol.param_marketOutFund_qd.param.paymentType = 1
      const that = this
      this.btnDisenable = true
      this.loading = true
      http
        .postFrontMarket0(protocol.param_marketOutFund_qd)
        .then(response => {
          const { code, message } = response.data
          that.btnDisenable = false
          that.loading = false
          if (code === '0' || code === 0) {
            this.$message('提交成功')
            this.ruleForm.password = ''
            this.ruleForm.amount = null
            setTimeout(() => {
              that.getMyAccount()
            }, 1000)
          } else {
            this.$message(message)
          }
        })
        .catch(response => {
          that.btnDisenable = false
          that.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#MyWithdraw {
  .el-button--primary{
    span{
      color: #fff !important;
    }
  }
  .el-pagination {
    padding: 50px 0 20px 0;
  }
  .headerContent {
    height: 68px;
    line-height: 68px;
    margin: 20px;
    background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    .contentWrap1 {
      display: flex;
      justify-content: flex-end;
      p {
        padding-right: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        span {
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
  }
  .centerContent {
    display: flex;
    margin: 0 20px;
    margin-bottom: 20px;
    .textWrap {
      background-color: #262941;
    }
    .el-icon-warning {
      color: #ff4d4d;
    }
    .tip {
      height: 55px;
      line-height: 55px;
      font-size: 14px;
      text-align: center;
      color: #ff4d4d;
      background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      span {
        color: #ff3333;
      }
    }
    .desc {
      font-size: 18px;
      height: 88px;
      line-height: 88px;
      // width: 90%;
      margin: 0 40px;
      display: flex;
      justify-content: space-between;
      // margin: 0 98px;
      border-bottom: 1px solid rgba(216, 216, 216, 0.2);
      .title {
        width: 30%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.6);
      }
      .text1 {
        width: 60%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
      }
      .iconCopy {
        width: 10%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        color: #0486fe;
        cursor: pointer;
      }
    }
    .topTitle {
      font-size: 20px;
      padding-bottom: 20px;
      padding-left: 20px;
      font-weight: 500;
      color: #ffffff;
    }
    .rightContent {
      .title {
        width: 20%;
      }
      .el-input {
        width: 80%;
      }
      /deep/ .el-input__inner {
        background-color: #262941;
        border: none;
      }
    }
    .btnWrap {
      text-align: center;
      padding: 24px 0;
      .el-button {
        width: 108px;
        height: 40px;
      }
    }
  }
  .centerContent > div {
    width: 50%;
  }
  .centerContent > div:first-child {
    margin-right: 20px;
  }
  .leftContent .bankDetailsWrap > div:last-child {
    border-bottom: none;
  }
  .flow {
    .headerWrap {
      display: flex;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      margin-bottom: 8px;
      background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      .leftText {
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
      }
      .rightText {
        display: flex;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
        .selectText {
          padding-right: 10px;
        }
        /deep/ .el-input__inner {
          height: 34px;
          line-height: 34px;
          background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
          border: 1px solid rgba(220, 223, 230, 0.3);
        }
        /deep/ .el-date-editor .el-range-input {
          background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
        }
        .el-button {
          padding: 7px 25px;
        }
      }
    }
  }
  .eyeStyle {
    width: 22px;
    cursor: pointer;
    vertical-align: middle;
  }
  /deep/ .el-input__inner {
    color: rgba(255, 255, 255, 0.9);
  }
}
</style>
